import React, { useState } from 'react';
import './AuthTemplate.css';

import Login from './Login';
import OTP from './OTP';
import SignUp from './SignUp';

import GirlPhoneImage from '../../assets/login-assets/girl_phone.png';
import PhoneImage from '../../assets/login-assets/phone_group.png';
import Dashboard from "../Dashboard/Dashboard";
import { STEPS } from '../../constants';
import {useDispatch} from 'react-redux';
import {setIsLoggedIn} from '../../redux/admin/userActions.js';


const AuthTemplate = (props) => {
	const dispatch=useDispatch();
	
	
	const [step, setStep] = useState(STEPS.LOGIN);
	const [phoneNumber, setPhoneNumber] = useState('');
	const changeStep = (nextStep) => {
		setStep(nextStep);
	};
	let content="";
	let dashboard="";
	switch (step) {
		case STEPS.LOGIN:
			content = (
				<Login
					phoneNumber={phoneNumber}
					setPhoneNumber={setPhoneNumber}
					changeStep={changeStep}
					nextStep={STEPS.OTP}
				/>
			);
			break;
		case STEPS.OTP:
			content = (
				<OTP phoneNumber={phoneNumber} changeStep={changeStep} nextStep={STEPS.DASHBOARD} prevState={STEPS.LOGIN} />
			);
			break;
		case STEPS.DASHBOARD:
			
			
			dispatch(setIsLoggedIn(true));
			dashboard=(<Dashboard />)
			break;
		default:
			break;
	}
	return (
		dashboard===""?
		<div className='AuthTemplate'>
		<div className='row'>
			<div className='col s12 l4 data'>{content}</div>
			<div className='col s4 hide-on-med-and-down'>
				<img src={GirlPhoneImage} className='girl-phone' />
			</div>
			<div className='col s4 hide-on-med-and-down'>
				<img src={PhoneImage} className='phone-group' />
			</div>
		</div>
	</div>:dashboard
		
		
	);
};

export default AuthTemplate;
